import getDefaultFont from "./getDefaultFont";

export default (function measureText() {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    let lastfont;

    return (text = "", {size = 14, font, weight = "normal", fontFamily} = {}) => {
        font = font || `${weight} ${size}px ${fontFamily || getDefaultFont()}`;
        if (font !== lastfont) {
            ctx.font = font;
            lastfont = font;
        }
        return ctx.measureText(text).width;
    };
})();


// WEBPACK FOOTER //
// ./src/lib/measureText.js